/* eslint-disable */
import React, { Component } from 'react'
import MUIDataTable from 'mui-datatables'
import gql from 'graphql-tag'
import { Query, withApollo } from 'react-apollo'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import getLoginId from '../../../utils/getLoginId'
import FileSaver from 'file-saver'
import axios from 'axios'
import moment from 'moment'
import Loader from '../../../components/common/Loader'

import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'

const GET_CLIENTS = gql`
  query allClientDetails($partnerLoginId: Int) {
    clients: allClientDetails(partnerLoginId: $partnerLoginId) {
      id
      clientName
      contactPerson
      contactNumber
      email
      totalAssignedVehicle
      plan {
        id
        planName
      }
      loginId
      trackingDetails {
        trackingCount
        nonTrackingCount
      }
      createdAt
      type
      zonalManager
      keyAccountManager
      channelPartnerName
      solutionMaster {
        id
        solutionTypeName
      }
      totalPotentialVehicles
    }
  }
`

const GET_CLIENTS_LIMITED = gql`
  query AllClientDetailsLimited($partnerLoginId: Int) {
    clients: allClientDetailsLimited(partnerLoginId: $partnerLoginId) {
      id
      clientName
      contactPerson
      email
      contactNumber
      planName
      totalVehicles
      createdAt
      accountType
      zonalManager
      keyAccountManager
      channelPartnerName
      loginId
      totalPotentialVehicles
    }
  }
`


const GET_FILE_FORMAT = gql`
  query getPublicDownloadURL($bucketname: String!, $filename: String!) {
    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)
  }
`
const GET_ZM_KAM_DETAILS = gql`
  query GetAdminUserDetailsByRole($roleName: [String]) {
    getAdminUserDetailsByRole(roleName: $roleName) {
      id
      role
      username
    }
  }
`;
const roleNames = ["Zonal Manager(ZM)", "Key Account Manager(KAM)"];

const style = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 2
    },
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  iconSmall: {
    fontSize: 20
  }
})

class Customers extends Component {
  constructor(props) {
    super(props)
    this.classes = props
  }

  state = {
    rowsPerPage: 15,
    viewMore: false
  }

  loginId = []
  fullData = []

  columns = [
    'CLIENT NAME',
    'CONTACT PERSON',
    'EMAIL',
    'PHONE NUMBER',
    'TOTAL VEHICLES',
    'TRACKING VEHICLES',
    'NONTRACKING VEHICLES',
    'PLAN',
    'CREATED DATE',
    'ACCOUNT TYPE',
    'ZONAL MANAGER',
    'KEY ACCOUNT MANAGER',
    'CHANNEL PARTNER',
    {
      name: 'SOLUTION',
      options: {
        setCellProps: () => ({
          style: {
            minWidth: '250px',
            maxWidth: '400px',
            whiteSpace: 'normal',
            wordWrap: 'break-word'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            minWidth: '250px',
            maxWidth: '400px'
          }
        }),
        customBodyRender: (value) => {
          if (!value) return '-';
          const lines = value.split(',').map(name => name.trim()).join('<br/>');
          return <span dangerouslySetInnerHTML={{ __html: lines }} />;
        }
      }
    },
    'TOTAL POTENTIAL VEHICLES'
  ];

  limitedColumns = [
    'CLIENT NAME',
    'CONTACT PERSON',
    'EMAIL',
    'PHONE NUMBER',
    'TOTAL VEHICLES',
    'PLAN',
    'CREATED DATE',
    'ACCOUNT TYPE',
    'ZONAL MANAGER',
    'KEY ACCOUNT MANAGER',
    'CHANNEL PARTNER',
    'TOTAL POTENTIAL VEHICLES'
  ];


  options = {
    selectableRows: false,
    filter: false,
    responsive: 'scroll',
    rowsPerPage: 15,
    print: false,
    onRowClick: (rowData, dataIndex, rowIndex) => {
      this.props.history.push({
        pathname: '/home/customers/view/' + this.loginId[dataIndex.dataIndex]
      })
    }
  }
  onChangeRowsPerPage = rowsPerPage => {
    this.setState({ rowsPerPage })
  }

  mapToArr(clients, zonalManagers, keyAccountManagers) {
    this.fullData = []
    this.loginId = []
    const { viewMore } = this.state

    clients.forEach(element => {
      let rowData = []
      this.loginId.push(element.loginId)
      rowData.push(element.clientName)
      rowData.push(element.contactPerson)
      rowData.push(element.email)
      rowData.push(element.contactNumber)

      if (viewMore) {
        // Full Data mapping
        let trackingCount = element.trackingDetails
          ? element.trackingDetails.trackingCount
          : 'NA'
        let nonTrackingCount = element.trackingDetails
          ? element.trackingDetails.nonTrackingCount
          : 'NA'
        rowData.push(element.totalAssignedVehicle)
        rowData.push(trackingCount)
        rowData.push(nonTrackingCount)
        if (element.plan) {
          rowData.push(element.plan.planName)
        } else {
          rowData.push('NA')
        }
        rowData.push(this.getFormattedDate(element.createdAt))
        rowData.push(element.type)
      } else {
        // Limited Data mapping
        rowData.push(element.totalVehicles)
        rowData.push(element.planName || 'NA')
        rowData.push(this.getFormattedDate(element.createdAt))
        rowData.push(element.accountType)
      }

      if (element.zonalManager) {
        const zm = zonalManagers.find(zm => zm.id === element.zonalManager);
        rowData.push(zm ? zm.username : element.zonalManager || '-');
      } else {
        rowData.push('-');
      }
      if (element.keyAccountManager) {
        const kam = keyAccountManagers.find(kam => kam.id === element.keyAccountManager);
        rowData.push(kam ? kam.username : element.keyAccountManager || '-');
      } else {
        rowData.push('-');
      }
      if (element.channelPartnerName) {
        rowData.push(element.channelPartnerName);
      } else {
        rowData.push("-");
      }

      if (viewMore) {
        if (Array.isArray(element.solutionMaster) && element.solutionMaster.length > 0) {
          const solutionNames = element.solutionMaster.map(s => s.solutionTypeName).join(', ')
          rowData.push(solutionNames)
        } else {
          rowData.push('-')
        }
        rowData.push(element.totalPotentialVehicles || 0)
      } else {
        rowData.push(element.totalPotentialVehicles || 0)
      }

      this.fullData.push(rowData)
    })
  }

  handleToggleChange = event => {
    this.setState({ viewMore: event.target.checked })
  }

  addCustomer = e => {
    this.props.history.push({
      pathname: '/home/customers/add'
    })
  }

  addBulkCustomer = e => {
    this.props.history.push({
      pathname: '/home/customers/BulkRegister'
    })
  }

  downloadBulkUpload = client => async event => {
    const { data } = await this.props.client.query({
      query: GET_FILE_FORMAT,
      variables: {
        bucketname: 'excel-templates',
        filename: 'clientUpload.xlsx'
      },
      errorPolicy: 'all'
    })

    const res = await axios({
      url: data.getPublicDownloadURL,
      method: 'GET',
      headers: { Accept: 'application/vnd.ms-excel' },
      responseType: 'blob' // important
    })

    FileSaver.saveAs(new Blob([res.data]), 'sample.xlsx')
  }
  getFormattedDate = timestamp => moment(timestamp * 1000).format('DD-MM-YYYY')

  render() {
    const { classes } = this.props

    const options = {
      selectableRows: false,
      filter: false,
      responsive: 'scroll',
      rowsPerPage: this.state.rowsPerPage,
      onChangeRowsPerPage: this.onChangeRowsPerPage,
      onRowClick: (rowData, dataIndex, rowIndex) => {
        this.props.history.push({
          pathname: '/home/customers/view/' + this.loginId[dataIndex.dataIndex]
        })
      }
    }

    return (
      <div className={classes.root}>
        <Grid container spacing={16}>
          <Grid item xs={12}>
            <Grid container justify="space-between" spacing={16} alignItems="center">
              <Grid item>
                <Typography variant="headline">Customers</Typography>
              </Grid>

              <Grid item>
                <Grid container spacing={8} justify="flex-end" alignItems="center">
                  <Grid item>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={this.state.viewMore}
                          onChange={this.handleToggleChange}
                          color="primary"
                        />
                      }
                      label="View More Details"
                    />
                  </Grid>
                  <Grid item xs={12} sm={'auto'}>
                    <Button
                      fullWidth
                      color="secondary"
                      onClick={this.addCustomer}
                      variant="raised"
                      className={this.classes.button}
                    >
                      Add Customer
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} style={{ width: '95%' }}>
            <Query
              query={this.state.viewMore ? GET_CLIENTS : GET_CLIENTS_LIMITED}
              variables={{
                partnerLoginId: getLoginId()
              }}
              fetchPolicy={this.state.viewMore ? "network-only" : "cache-first"}
            >
              {({ loading: loadingClients, error: errorClients, data = {} }) => {
                const clients = data.clients || [];
                return (
                  <Query
                    query={GET_ZM_KAM_DETAILS}
                    variables={{
                      roleName: roleNames
                    }}
                  // fetchPolicy="network-only"
                  >
                    {({ loading: loadingZMKAM, error: errorZMKAM, data: { getAdminUserDetailsByRole } = {} }) => {
                      if (loadingClients || loadingZMKAM) return <Loader />;
                      if (errorClients) return `Error with clients: ${errorClients.message}`;
                      if (errorZMKAM) return `Error with ZM/KAM details: ${errorZMKAM.message}`;

                      // Process clients and ZM/KAM details
                      const zonalManagers = getAdminUserDetailsByRole ? getAdminUserDetailsByRole.filter(user => user.role === "Zonal Manager(ZM)") : [];
                      const keyAccountManagers = getAdminUserDetailsByRole ? getAdminUserDetailsByRole.filter(user => user.role === "Key Account Manager(KAM)") : [];
                      this.mapToArr(clients, zonalManagers, keyAccountManagers)

                      return (
                        <MUIDataTable
                          data={this.fullData}
                          columns={this.state.viewMore ? this.columns : this.limitedColumns}
                          options={options}
                        />
                      )
                    }}
                  </Query>
                )
              }}
            </Query>
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default withStyles(style)(
  withApollo(withSharedSnackbar(Customers))
)


// WEBPACK FOOTER //
// ./src/components/Pages/Customers/index.jsx